import axios from "axios"

export const getCostaRicaDistrictDetails = async (lat: number, lng: number) => {
  try {
    const nominatimResponse = await axios.get("https://nominatim.openstreetmap.org/reverse", {
      params: {
        lat: lat,
        lon: lng,
        format: "json",
        addressdetails: 1,
        countrycodes: "cr",
        zoom: 18,
        "accept-language": "es",
      },
      headers: {
        "User-Agent": "PropertyApp/1.0",
      },
    })

    const address = nominatimResponse.data.address || {}

    console.log("Datos completos de Nominatim:", address)

    const rawNeighborhood = address.neighbourhood || address.neighborhood || address.suburb || address.city_district || ""

    const neighborhood = rawNeighborhood ? `Barrio ${rawNeighborhood}` : ""

    const nominatimDistrict = address.city || address.village || address.town || address.district || ""

    console.log("Barrio detectado en Nominatim:", rawNeighborhood)
    console.log("Barrio formateado:", neighborhood)
    console.log("Posible distrito detectado en Nominatim:", nominatimDistrict)

    console.log("Buscando distrito oficial con Overpass API...")

    const overpassQuery = `
      [out:json];
      is_in(${lat},${lng})->.a;
      area.a["admin_level"="8"]["boundary"="administrative"];
      out body;
      out tags;
    `

    const overpassResponse = await axios.post("https://overpass-api.de/api/interpreter", overpassQuery, {
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    })

    let districtName = ""
    let cantonName = ""
    let provinceName = ""

    if (overpassResponse.data && overpassResponse.data.elements && overpassResponse.data.elements.length > 0) {
      const elements = overpassResponse.data.elements

      const districtElement = elements.find(
        (el: any) => el.tags && el.tags.admin_level === "8" && el.tags.boundary === "administrative",
      )

      if (districtElement && districtElement.tags) {
        districtName = districtElement.tags.name || districtElement.tags["name:es"] || ""
        console.log("Distrito oficial encontrado en Overpass:", districtName)
      }

      const cantonQuery = `
        [out:json];
        is_in(${lat},${lng})->.a;
        area.a["admin_level"="6"]["boundary"="administrative"];
        out body;
        out tags;
      `

      const cantonResponse = await axios.post("https://overpass-api.de/api/interpreter", cantonQuery, {
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      })

      if (cantonResponse.data && cantonResponse.data.elements && cantonResponse.data.elements.length > 0) {
        const cantonElement = cantonResponse.data.elements.find(
          (el: any) => el.tags && el.tags.admin_level === "6" && el.tags.boundary === "administrative",
        )

        if (cantonElement && cantonElement.tags) {
          cantonName = cantonElement.tags.name || cantonElement.tags["name:es"] || ""
          console.log("Cantón encontrado en Overpass:", cantonName)
        }
      }

      const provinceQuery = `
        [out:json];
        is_in(${lat},${lng})->.a;
        area.a["admin_level"="4"]["boundary"="administrative"];
        out body;
        out tags;
      `

      const provinceResponse = await axios.post("https://overpass-api.de/api/interpreter", provinceQuery, {
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      })

      if (provinceResponse.data && provinceResponse.data.elements && provinceResponse.data.elements.length > 0) {
        const provinceElement = provinceResponse.data.elements.find(
          (el: any) => el.tags && el.tags.admin_level === "4" && el.tags.boundary === "administrative",
        )

        if (provinceElement && provinceElement.tags) {
          provinceName = provinceElement.tags.name || provinceElement.tags["name:es"] || ""
          console.log("Provincia encontrada en Overpass:", provinceName)
        }
      }
    }

    const finalDistrict = districtName || nominatimDistrict

    console.log("Distrito final:", finalDistrict)
    console.log("Barrio final:", neighborhood)

    return {
      ...address,
      district: finalDistrict,
      county: cantonName || address.county || address.municipality || "",
      province: provinceName || address.state || address.province || "",
      neighborhood: neighborhood,
    }
  } catch (error) {
    console.error("Error obteniendo detalles del distrito:", error)
    return {}
  }
}
